import { SearchBar } from '@trg/tlw-ui-component';
import { useHeaderData, selectSearchTmp } from '../../../header';
import { useSearchStore } from '../../stores';
import { generateSearchPagePath } from '../../utils';

export function SearchField() {
  const setKeyword = useSearchStore.use.setKeyword();
  const setIsSearchOpen = useSearchStore.use.setIsSearchOpen();
  const addRecentSearch = useSearchStore.use.addRecentSearch();

  const headerData = useHeaderData();
  const { mainHeading, link } = selectSearchTmp(headerData) ?? {};

  const handleChange = (value: string) => {
    setKeyword(value);
  };

  const handleSearch = (value: string) => {
    if ((!value || value === mainHeading) && link) {
      window.location.href = link;
      return;
    }
    addRecentSearch(value);
    const paht = generateSearchPagePath(value);
    window.location.href = paht;
  };

  const close = () => {
    setIsSearchOpen(false);
    setKeyword('');
  };

  return (
    <div className="search__input tlw-py-3 tlw-px-4 tlw-flex tlw-items-center tlw-gap-2.5 lg:tlw-px-0">
      <SearchBar
        className="search__input tlw-flex-1"
        placeholder={mainHeading}
        debounceTime={500}
        autoFocus
        onChangeHandler={handleChange}
        onSearch={handleSearch}
      />

      <button
        className="tlw-txt-zh-body-1 tlw-text-txt-800 lg:tlw-hidden"
        onClick={close}
      >
        取消
      </button>
    </div>
  );
}
